import React from "react";
import heroImage from "../assets/hero.jpg"; // reemplazar con tu imagen

function Hero({ title, subtitle }) {
  return (
    <div className="hero-container">
      <img src={heroImage} alt="Imagen hero" />
      <div className="hero-text">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
  );
}

export default Hero;
